import React, { useEffect, useState } from "react";
import { useHistory, useLocation } from "react-router-dom";
import QrEventTable from "./component/QrEventTable";
import ParticipantTable from "./component/QrEventParticipantsTable";

// MUI
import { Box, Button, Paper, Tabs, Tab, Typography } from "@mui/material";

import SettingsIcon from "@mui/icons-material/Settings";
import GroupIcon from "@mui/icons-material/Group";
import QrCode2Icon from "@mui/icons-material/QrCode2";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import { ds } from "../../../styles/designSystem";
import ActionButton from "../../../component/common/ActionButton";

function TabPanel({ value, index, children }) {
    if (value !== index) return null;
    return <Box>{children}</Box>;
}

export default function QrEventAdminListPage() {
    const history = useHistory();
    const location = useLocation();
    const [tab, setTab] = useState(0); // 0: 행사관리, 1: 참가자관리

    // ✅ 참가자 탭에서 자동 선택할 행사명 (상위에서 들고 있음)
    const [participantEventName, setParticipantEventName] = useState("");

    useEffect(() => {
        const tabParam = new URLSearchParams(location.search).get("tab");
        setTab(tabParam === "participants" ? 1 : 0);
    }, [location.search]);

    const handleChange = (_, newValue) => {
        if (newValue !== 0 && newValue !== 1) return;
        setTab(newValue);
        history.replace(`/qr-event-admin-list?tab=${newValue === 1 ? "participants" : "events"}`);
    };

    // ✅ 행사관리에서 "참가자 관리" 눌렀을 때
    const goParticipants = (eventName) => {
        setParticipantEventName(eventName);
        setTab(1);
        history.replace("/qr-event-admin-list?tab=participants");
    };

    return (
        <Box sx={{ maxWidth: 1600, mx: "auto", px: 3, py: 3 }}>
            <Box sx={{ display: "flex", alignItems: "flex-start", gap: 1.5, mb: 2.5 }}>
                <Box>
                    <Typography sx={ds.typography.pageTitle}>
                        LED 포토존 행사 &amp; 참가자 관리
                    </Typography>
                    <Typography sx={ds.typography.pageSubtitle}>
                        행사(등록, 수정, 삭제) + 행사별 참가자 관리를 진행합니다
                    </Typography>
                </Box>
                <Box sx={{ flex: 1 }} />
            </Box>

            <Paper sx={{ ...ds.card, mb: 3 }}>
                <Tabs
                    value={tab}
                    onChange={handleChange}
                    variant="scrollable"
                    scrollButtons="auto"
                    sx={ds.components.tabs.root}
                >
                    <Tab label="행사 관리" value={0} />
                    <Tab label="참가자 관리" value={1} />
                </Tabs>
            </Paper>

            <TabPanel value={tab} index={0}>
                <QrEventTable
                    key="event-table"
                    onGoParticipants={goParticipants}   // ✅ 여기 연결
                />
            </TabPanel>

            <TabPanel value={tab} index={1}>
                <ParticipantTable
                    key="participant-table"
                    selectedEventFromParent={participantEventName}            // ✅ 자동 선택
                    onSelectedEventChange={(name) => setParticipantEventName(name)} // ✅ 드롭다운 변경 시 동기화
                />
            </TabPanel>
        </Box>
    );
}
